import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Login } from '../modules/authentication/Login'
import {StaffLogin} from "../modules/authentication/StaffLogin";

export const NoAuthRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={'/login'} element={<Login />} />
      <Route path={'/staff-login'} element={<StaffLogin />} />
      {/* Redirect others to login */}
      <Route path={'*'} element={<Navigate to={'/login'} />} />
    </Routes>
  )
}
